export interface Movie {
  id: string;
  title: string;
  category: 'dianying' | 'dianshiju' | 'dongman' | 'zongyi';
  categoryLabel: string;
  poster: string;
  year: number;
  rating: number;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  tags: string[];
  updateDate: string;
}

export const categories = [
  { slug: 'dianying', label: '电影', icon: 'ri-film-line' },
  { slug: 'dianshiju', label: '电视剧', icon: 'ri-tv-line' },
  { slug: 'dongman', label: '动漫', icon: 'ri-ancient-gate-line' },
  { slug: 'zongyi', label: '综艺', icon: 'ri-live-line' },
] as const;

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'dianying',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20Earth%20in%20space%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20clean%20minimal%20background%2C%20movie%20poster%20design%20style%2C%20professional%20typography%20space%2C%20warm%20golden%20and%20deep%20blue%20color%20scheme&width=600&height=840&seq=pipi-movie-01&orientation=portrait',
    year: 2027,
    rating: 8.5,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代的航天员挺身而出，展开了争分夺秒的生死之战。本片是中国科幻电影的里程碑之作，以其宏大的叙事格局和震撼的视觉效果，讲述了人类在绝境中求生存的动人故事。影片融合了硬核科幻元素与东方家庭价值观，为观众呈现了一场视听盛宴。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '173分钟',
    region: '中国大陆',
    tags: ['科幻', '灾难', '冒险', 'IMAX'],
    updateDate: '2026-08-10',
  },
  {
    id: 'movie-2',
    title: '封神第二部：战火西岐',
    category: 'dianying',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20Chinese%20warriors%20and%20mythical%20beasts%2C%20epic%20battle%20scene%2C%20golden%20and%20crimson%20color%20scheme%2C%20clean%20background%2C%20movie%20poster%20style%2C%20professional%20design&width=600&height=840&seq=pipi-movie-02&orientation=portrait',
    year: 2025,
    rating: 7.9,
    description: '殷商大军兵临西岐城下，姜子牙率领众将士浴血奋战。姬发在战火中逐渐成长为真正的领袖，而妲己的真实身份也浮出水面。一部融合神话史诗与视听奇观的东方奇幻巨制，展现了中国古代神话的无穷魅力与想象力。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    duration: '148分钟',
    region: '中国大陆',
    tags: ['奇幻', '神话', '动作', '史诗'],
    updateDate: '2026-08-08',
  },
  {
    id: 'movie-3',
    title: '满江红',
    category: 'dianying',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20Chinese%20palace%20courtyard%2C%20soldiers%20in%20traditional%20armor%2C%20dark%20red%20and%20black%20color%20scheme%2C%20mysterious%20atmosphere%2C%20clean%20background%2C%20movie%20poster%20style&width=600&height=840&seq=pipi-movie-03&orientation=portrait',
    year: 2023,
    rating: 7.4,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相秦桧驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中，宰相秦桧命两人限一个时辰之内找到凶手。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    region: '中国大陆',
    tags: ['剧情', '悬疑', '历史', '喜剧'],
    updateDate: '2026-08-05',
  },
  {
    id: 'movie-4',
    title: '深海',
    category: 'dianying',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20with%20underwater%20dreamlike%20scene%2C%20colorful%20sea%20creatures%2C%20a%20young%20girl%20diving%2C%20vibrant%20ink%20wash%20painting%20style%2C%20ethereal%20lighting%2C%20clean%20background%2C%20artistic%20poster%20design&width=600&height=840&seq=pipi-movie-04&orientation=portrait',
    year: 2023,
    rating: 7.8,
    description: '在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。这是中国原创的视觉奇观，用极致的水墨粒子动画展现了一个绚烂多彩的深海梦境，每一帧都是一幅精美的画作。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文'],
    duration: '112分钟',
    region: '中国大陆',
    tags: ['动画', '奇幻', '冒险', '水墨'],
    updateDate: '2026-08-03',
  },
  {
    id: 'movie-5',
    title: '无名',
    category: 'dianying',
    categoryLabel: '电影',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20spy%20thriller%20movie%20poster%20with%201940s%20Shanghai%20atmosphere%2C%20man%20in%20trench%20coat%2C%20noir%20lighting%2C%20dark%20green%20and%20gold%20color%20scheme%2C%20mysterious%20mood%2C%20clean%20background%2C%20movie%20poster%20style&width=600&height=840&seq=pipi-movie-05&orientation=portrait',
    year: 2023,
    rating: 6.8,
    description: '影片通过对上世纪二十年代开始奋斗在上海的中国共产党领导下的中共特科，在隐蔽战线与各方势力殊死较量过程的再现，表现了在走向胜利过程中不可或缺的党的秘密战线上那些无名英雄。',
    director: '程耳',
    actors: ['梁朝伟', '王一博', '周迅', '黄磊'],
    duration: '128分钟',
    region: '中国大陆',
    tags: ['谍战', '悬疑', '历史', '剧情'],
    updateDate: '2026-07-28',
  },
  {
    id: 'tv-1',
    title: '庆余年第二季',
    category: 'dianshiju',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20TV%20series%20poster%20with%20man%20in%20traditional%20Chinese%20robe%20holding%20sword%2C%20palace%20background%2C%20golden%20and%20emerald%20color%20scheme%2C%20elegant%20composition%2C%20clean%20background%2C%20drama%20poster%20style&width=600&height=840&seq=pipi-movie-06&orientation=portrait',
    year: 2024,
    rating: 8.0,
    description: '范闲从北齐归来后，发现自己身世之谜逐渐揭开，各方势力围绕他的博弈愈发激烈。面对朝堂之上的明争暗斗与江湖之中的刀光剑影，范闲必须在忠诚与背叛、真相与谎言之间做出抉择。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    duration: '36集',
    region: '中国大陆',
    tags: ['古装', '权谋', '武侠', '剧情'],
    updateDate: '2026-08-09',
  },
  {
    id: 'tv-2',
    title: '繁花',
    category: 'dianshiju',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20nostalgic%20drama%20TV%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20man%20and%20woman%20in%20vintage%20clothing%2C%20neon%20lights%2C%20warm%20golden%20tone%2C%20retro%20atmosphere%2C%20clean%20background%2C%20drama%20poster%20style&width=600&height=840&seq=pipi-movie-07&orientation=portrait',
    year: 2023,
    rating: 8.7,
    description: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人争当弄潮儿。阿宝与至真园老板娘李李、小宁波老板玲子、外贸大楼汪小姐之间的故事，讲述了一个时代的变迁与上海人的奋斗精神。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '30集',
    region: '中国大陆',
    tags: ['年代', '都市', '商战', '爱情'],
    updateDate: '2026-08-07',
  },
  {
    id: 'tv-3',
    title: '漫长的季节',
    category: 'dianshiju',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20crime%20drama%20TV%20poster%20with%20autumn%20northeast%20China%20industrial%20city%2C%20three%20men%20standing%20in%20fallen%20leaves%2C%20melancholic%20warm%20amber%20tone%2C%20nostalgic%20atmosphere%2C%20clean%20background%2C%20drama%20poster&width=600&height=840&seq=pipi-movie-08&orientation=portrait',
    year: 2023,
    rating: 9.4,
    description: '一桩跨越二十年的悬案，将三个不同年代的男人紧密联系在一起。东北小城桦林，出租车司机王响、妹夫龚彪、刑警支队前队长马德胜，三人因为一桩碎尸案而命运交织，在漫长的季节里，他们各自追寻着真相。',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希'],
    duration: '12集',
    region: '中国大陆',
    tags: ['悬疑', '犯罪', '剧情', '年代'],
    updateDate: '2026-08-06',
  },
  {
    id: 'tv-4',
    title: '狂飙',
    category: 'dianshiju',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20action%20drama%20TV%20poster%20with%20two%20men%20facing%20off%2C%20police%20and%20gangster%20contrast%2C%20dark%20urban%20cityscape%2C%20intense%20red%20and%20black%20color%20scheme%2C%20clean%20background%2C%20drama%20poster%20style&width=600&height=840&seq=pipi-movie-09&orientation=portrait',
    year: 2023,
    rating: 8.5,
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。在全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子，粉碎了黑恶势力的保护伞。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    duration: '39集',
    region: '中国大陆',
    tags: ['犯罪', '剧情', '扫黑', '动作'],
    updateDate: '2026-08-04',
  },
  {
    id: 'tv-5',
    title: '三体',
    category: 'dianshiju',
    categoryLabel: '电视剧',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20TV%20poster%20with%20three%20suns%20in%20sky%2C%20mysterious%20radio%20telescope%2C%20cosmic%20background%2C%20dark%20blue%20and%20silver%20color%20scheme%2C%20scientific%20atmosphere%2C%20clean%20background%2C%20drama%20poster&width=600&height=840&seq=pipi-movie-10&orientation=portrait',
    year: 2023,
    rating: 8.1,
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。离奇自杀的科学家，近乎神迹的倒计时，行事隐秘的科学边界，神秘莫测的《三体》游戏。纳米科学家汪淼被警官史强带到联合作战中心，潜入"科学边界"组织协助调查。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    duration: '30集',
    region: '中国大陆',
    tags: ['科幻', '悬疑', '剧情', '文学改编'],
    updateDate: '2026-08-02',
  },
  {
    id: 'anime-1',
    title: '哪吒之魔童降世',
    category: 'dongman',
    categoryLabel: '动漫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20a%20rebellious%20young%20boy%20with%20fire%20powers%2C%20flaming%20wheels%20under%20feet%2C%20Chinese%20mythology%20style%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20dynamic%20action%20pose%2C%20clean%20background%2C%20animation%20poster&width=600&height=840&seq=pipi-movie-11&orientation=portrait',
    year: 2019,
    rating: 8.4,
    description: '天地灵气孕育出一颗混元珠，元始天尊将其提炼成灵珠和魔丸。灵珠投胎为人，助周伐纣时可堪大用；而魔丸则会诞出魔王，为祸人间。元始天尊启动了天劫咒语，三年后天雷将会降临，摧毁魔丸。然而阴差阳错，灵珠和魔丸被掉包。',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    duration: '110分钟',
    region: '中国大陆',
    tags: ['动画', '神话', '喜剧', '动作'],
    updateDate: '2026-08-10',
  },
  {
    id: 'anime-2',
    title: '长安三万里',
    category: 'dongman',
    categoryLabel: '动漫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20with%20ancient%20Tang%20Dynasty%20capital%20city%20Changan%2C%20poets%20on%20horseback%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20golden%20sunset%20color%2C%20grand%20palace%20architecture%2C%20clean%20background%2C%20animation%20poster&width=600&height=840&seq=pipi-movie-12&orientation=portrait',
    year: 2023,
    rating: 8.3,
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。两位大诗人在盛世与乱世中的命运交织，谱写了一曲壮阔的大唐史诗。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    duration: '168分钟',
    region: '中国大陆',
    tags: ['动画', '历史', '诗歌', '传记'],
    updateDate: '2026-08-01',
  },
  {
    id: 'anime-3',
    title: '雾山五行',
    category: 'dongman',
    categoryLabel: '动漫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20anime%20poster%20with%20warrior%20surrounded%20by%20five%20elemental%20powers%20fire%20water%20wood%20metal%20earth%2C%20ink%20wash%20painting%20style%2C%20dynamic%20combat%20pose%2C%20vibrant%20colors%2C%20clean%20background%2C%20animation%20poster&width=600&height=840&seq=pipi-movie-13&orientation=portrait',
    year: 2023,
    rating: 9.2,
    description: '上古时期，妖兽纵横，一位神秘道人分别授予了阴阳五行的特殊能力给金木水火土五个家族来抵抗妖兽。他们将妖兽驱赶到神隐雾山之中，设立结界。雾山之中另有强大灵力的麒麟兽，常吸引妖兽试图突破结界，因此麒麟自愿被封印于巨阙神盾之中。',
    director: '林魂',
    actors: ['郭盛', '郝祥海', '叶知秋'],
    duration: '7集',
    region: '中国大陆',
    tags: ['动作', '奇幻', '武侠', '水墨'],
    updateDate: '2026-07-30',
  },
  {
    id: 'anime-4',
    title: '一人之下',
    category: 'dongman',
    categoryLabel: '动漫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20urban%20anime%20poster%20with%20young%20man%20using%20qi%20energy%20power%2C%20modern%20city%20background%2C%20Chinese%20Taoist%20elements%2C%20dynamic%20action%2C%20dark%20and%20neon%20color%20scheme%2C%20clean%20background%2C%20animation%20poster&width=600&height=840&seq=pipi-movie-14&orientation=portrait',
    year: 2016,
    rating: 8.8,
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚，和没有任何记忆的不老少女冯宝宝一起，开启了"异人"之旅。在这个异能者云集的世界里，张楚岚将面对各种势力和挑战。',
    director: '王昕',
    actors: ['夏侯落枫', '小连杀', '图特哈蒙'],
    duration: '共5季',
    region: '中国大陆',
    tags: ['动作', '奇幻', '都市', '热血'],
    updateDate: '2026-07-28',
  },
  {
    id: 'anime-5',
    title: '时光代理人',
    category: 'dongman',
    categoryLabel: '动漫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20suspense%20anime%20poster%20with%20two%20young%20men%20in%20photo%20studio%2C%20clock%20and%20time%20motif%2C%20warm%20vintage%20tone%2C%20mysterious%20atmosphere%2C%20photograph%20elements%2C%20clean%20background%2C%20animation%20poster&width=600&height=840&seq=pipi-movie-15&orientation=portrait',
    year: 2021,
    rating: 8.6,
    description: '在繁华都市的某个角落，有一家叫做"时光照相馆"的小店。虽然门庭冷落，但它其实由两个具有特殊能力的男人——程小时和陆光经营着。为了完成顾客的委托，两人组队配合使用超能力进入照片，然而事情的发展却没能按他们所想的那样。',
    director: '李豪凌',
    actors: ['杨天翔', '苏尚卿'],
    duration: '共2季',
    region: '中国大陆',
    tags: ['悬疑', '奇幻', '剧情', '催泪'],
    updateDate: '2026-07-25',
  },
  {
    id: 'variety-1',
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    categoryLabel: '综艺',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20outdoors%2C%20green%20nature%20background%2C%20energetic%20vibrant%20colors%2C%20fun%20atmosphere%2C%20clean%20background%2C%20variety%20show%20poster%20style&width=600&height=840&seq=pipi-movie-16&orientation=portrait',
    year: 2024,
    rating: 7.2,
    description: '全新一季奔跑吧以生态文明为主题，兄弟团成员携手飞行嘉宾走进中国各地的自然保护区，在趣味游戏中传递环保理念。节目融合竞技、搞笑与科普于一体，让观众在欢笑中感受大自然的美好与珍贵。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '沙溢', '白鹿', '周深'],
    duration: '共12期',
    region: '中国大陆',
    tags: ['真人秀', '竞技', '户外', '搞笑'],
    updateDate: '2026-08-09',
  },
  {
    id: 'variety-2',
    title: '向往的生活第七季',
    category: 'zongyi',
    categoryLabel: '综艺',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20countryside%20farmhouse%2C%20celebrities%20cooking%20and%20farming%2C%20warm%20rustic%20atmosphere%2C%20golden%20sunset%20light%2C%20green%20fields%2C%20cozy%20vibes%2C%20clean%20background%2C%20variety%20show%20poster&width=600&height=840&seq=pipi-movie-17&orientation=portrait',
    year: 2024,
    rating: 8.1,
    description: '回归山林，寻找内心的宁静。黄磊与何炅携手新老朋友，在风景如画的蘑菇屋里过着自给自足的田园生活。每一期都有新的客人到访，带来不同的故事与感动。这是一档关于友情、美食与慢生活的治愈系综艺。',
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    duration: '共14期',
    region: '中国大陆',
    tags: ['慢综艺', '美食', '田园', '治愈'],
    updateDate: '2026-08-08',
  },
  {
    id: 'variety-3',
    title: '歌手2025',
    category: 'zongyi',
    categoryLabel: '综艺',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20poster%20with%20spotlight%20on%20stage%2C%20microphone%2C%20dramatic%20stage%20lighting%2C%20dark%20background%20with%20golden%20accents%2C%20music%20theme%2C%20professional%20show%20poster%20style&width=600&height=840&seq=pipi-movie-18&orientation=portrait',
    year: 2025,
    rating: 7.8,
    description: '华语乐坛最强音对决再次袭来！顶级歌手齐聚舞台，用音乐讲述故事，用歌声传递情感。实力派与新生代的碰撞，经典曲目与原创作品的较量，每一期都带来震撼人心的音乐盛宴。',
    director: '洪涛',
    actors: ['那英', '华晨宇', '周深', '邓紫棋', '毛不易'],
    duration: '共13期',
    region: '中国大陆',
    tags: ['音乐', '竞演', '直播', '实力派'],
    updateDate: '2026-08-06',
  },
  {
    id: 'variety-4',
    title: '密室大逃脱第五季',
    category: 'zongyi',
    categoryLabel: '综艺',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20escape%20room%20variety%20show%20poster%20with%20mysterious%20locked%20room%2C%20celebrities%20solving%20puzzles%2C%20dark%20atmosphere%20with%20dramatic%20lighting%2C%20mystery%20theme%2C%20clean%20background%2C%20variety%20show%20poster&width=600&height=840&seq=pipi-movie-19&orientation=portrait',
    year: 2024,
    rating: 8.3,
    description: '明星嘉宾被困在精心设计的密室中，需要通过团队协作解开层层谜题才能逃脱。烧脑的机关设计、精妙的剧情编排、嘉宾们真实的恐惧反应，让观众仿佛身临其境。每一期都是一场智力的较量与勇气的考验。',
    director: '何舒',
    actors: ['杨幂', '邓伦', '黄明昊', '大张伟', '张国伟'],
    duration: '共12期',
    region: '中国大陆',
    tags: ['推理', '冒险', '搞笑', '悬疑'],
    updateDate: '2026-08-04',
  },
  {
    id: 'variety-5',
    title: '这就是街舞第六季',
    category: 'zongyi',
    categoryLabel: '综艺',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20street%20dance%20competition%20show%20poster%20with%20dancer%20in%20dynamic%20breaking%20pose%2C%20urban%20street%20style%2C%20vibrant%20neon%20colors%2C%20graffiti%20elements%2C%20cool%20hip%20hop%20vibe%2C%20clean%20background%2C%20show%20poster&width=600&height=840&seq=pipi-movie-20&orientation=portrait',
    year: 2024,
    rating: 8.0,
    description: '中国最具影响力的街舞竞技节目再度升级！来自全国各地的顶尖舞者齐聚舞台，在四位明星队长的带领下展开激烈对决。Breaking、Popping、Locking等多种街舞风格轮番上阵，每一场Battle都是视觉与节奏的极致享受。',
    director: '陆伟',
    actors: ['王一博', '韩庚', '刘雨昕', '李承铉'],
    duration: '共12期',
    region: '中国大陆',
    tags: ['舞蹈', '竞技', '潮流', '青年'],
    updateDate: '2026-08-02',
  },
];

export const featuredMovies = ['movie-1', 'movie-2', 'tv-2', 'anime-1', 'anime-3', 'variety-3'];

export const hotMovies = ['tv-3', 'tv-4', 'movie-3', 'anime-2', 'variety-4', 'variety-2', 'tv-1', 'anime-5'];

export const newMovies = ['movie-5', 'tv-5', 'anime-4', 'variety-1', 'variety-5', 'movie-4'];

export const testimonials = [
  {
    id: 1,
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20Chinese%20man%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=pipi-avatar-01&orientation=squarish',
    content: '屁屁影院真的太棒了！资源更新速度超级快，画质也是没得说。我每天下班回家就喜欢打开屁屁影院看最新的电影和电视剧，推荐给所有喜欢追剧的朋友们！',
    rating: 5,
  },
  {
    id: 2,
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20woman%20in%20her%2020s%2C%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=120&height=120&seq=pipi-avatar-02&orientation=squarish',
    content: '从大学开始就在用屁屁影院了，分类很全，动漫资源也很丰富。最赞的是不用注册就能看，省去了很多麻烦。界面也很简洁好看，强烈推荐！',
    rating: 5,
  },
  {
    id: 3,
    name: '老张',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20middle%20aged%20Chinese%20man%2C%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=pipi-avatar-03&orientation=squarish',
    content: '作为一个影视爱好者，我对片源质量要求很高。屁屁影院的高清画质和流畅播放体验让我很满意，而且片库更新很及时，新片上线速度非常快。',
    rating: 4,
  },
  {
    id: 4,
    name: '阿花',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20Chinese%20woman%20with%20glasses%2C%20gentle%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=120&height=120&seq=pipi-avatar-04&orientation=squarish',
    content: '手机、平板、电脑都能用，通勤路上追剧太方便了！而且分类特别细致，找片子很快。最近发现综艺板块也很好看，强烈安利《密室大逃脱》！',
    rating: 5,
  },
  {
    id: 5,
    name: '大刘',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20man%20in%20his%2030s%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=pipi-avatar-05&orientation=squarish',
    content: '国产动漫的资源最全！《雾山五行》《一人之下》这些我都是在屁屁影院追的。清晰度高，加载快，体验非常好。希望平台越来越好！',
    rating: 5,
  },
  {
    id: 6,
    name: '思思',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20Chinese%20woman%20with%20long%20hair%2C%20bright%20smile%2C%20clean%20white%20background%2C%20warm%20natural%20lighting%2C%20professional%20headshot&width=120&height=120&seq=pipi-avatar-06&orientation=squarish',
    content: '之前试过很多观影平台，最后锁定了屁屁影院。资源多、更新快、画质好，关键是完全免费！每天晚上和孩子一起看动漫，成了我们家的固定节目。',
    rating: 4,
  },
];

export const faqData = [
  {
    question: '屁屁影院需要注册才能观看吗？',
    answer: '不需要！屁屁影院完全免费，无需注册即可畅享所有影片资源。我们致力于为用户提供最简单便捷的观影体验，打开网站就能直接观看喜爱的电影、电视剧、动漫和综艺节目。',
  },
  {
    question: '屁屁影院的影片画质如何？',
    answer: '屁屁影院所有影片均提供高清画质，支持720P、1080P等多种清晰度选择。我们采用先进的视频压缩技术，在保证高清画质的同时，最大限度降低带宽消耗，让您在不同网络环境下都能流畅观看。',
  },
  {
    question: '屁屁影院的资源更新频率是怎样的？',
    answer: '屁屁影院的资源团队每天都会更新最新内容。热门电影、电视剧上线当天即可观看，动漫和综艺节目也会在播出后第一时间同步更新。我们承诺为用户提供最及时的观影资源。',
  },
  {
    question: '屁屁影院支持哪些设备观看？',
    answer: '屁屁影院支持多终端访问，您可以在电脑、平板、手机等设备上流畅观看。网站采用响应式设计，自动适配不同屏幕尺寸，无论您使用哪种设备，都能获得最佳的观影体验。',
  },
  {
    question: '在屁屁影院观看影片需要安装播放器吗？',
    answer: '不需要安装任何播放器或插件。屁屁影院采用先进的HTML5播放技术，使用浏览器自带的播放功能即可流畅观看所有影片，兼容Chrome、Safari、Edge等主流浏览器。',
  },
  {
    question: '屁屁影院的影片是否支持下载离线观看？',
    answer: '目前屁屁影院主要提供在线观看服务。我们建议您在有网络的环境下观看，以获得最佳的画质和流畅度体验。未来我们会考虑增加离线缓存功能，敬请期待。',
  },
  {
    question: '如何在屁屁影院找到想看的影片？',
    answer: '屁屁影院提供多种查找方式：您可以通过顶部的分类导航浏览不同类型的影片，也可以在首页的搜索框中直接搜索影片名称。此外，首页还有热门推荐和最新上线板块，帮助您发现精彩内容。',
  },
  {
    question: '屁屁影院的影片有广告吗？',
    answer: '屁屁影院致力于提供纯净的观影体验。我们尽量减少对用户观看体验的干扰，让您可以专注于享受精彩的影片内容。如果遇到任何播放问题，欢迎通过关于我们页面的联系方式反馈给我们。',
  },
];